import { shareListModalStyles as styles } from "@insite/content-library/Components/ShareListModal";
import getColor from "@insite/mobius/utilities/getColor";
import { colorStrings } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

styles.shareListTooltip = {
    ...styles.shareListTooltip,
    mergeCss: true,
};

styles.recipientEmailTooltip = {
    ...styles.recipientEmailTooltip,
    mergeCss: true,
};

styles.shareListOptionText = {
    ...styles.shareListOptionText,
    mergeCss: true,
    css: css`
        ${styles.shareListOptionText?.css}
        margin-bottom: 16px !important;
    `,
};

styles.shareByOptionGridItem = {
    ...styles.shareByOptionGridItem,
    css: css`
        ${styles.shareByOptionGridItem?.css}
        margin-top: 16px !important;
        margin-bottom: 16px !important;
    `,
};

styles.shareByOptionText = {
    ...styles.shareByOptionText,
    mergeCss: true,
    css: css`
        ${styles.shareByOptionText?.css}
        margin-bottom: 16px !important;
    `,
};

styles.sendCopyRadio = {
    ...styles.sendCopyRadio,
    css: css`
        ${styles.sendCopyRadio?.css}
        input[type="radio"] {
            &:disabled {
                & + label {
                    color: ${getColor(colorStrings.commonGlobalGray03)} !important;

                    &::before {
                        border-color: ${getColor(colorStrings.commonGlobalGray03)} !important;
                    }
                }
            }
        }
    `,
};

styles.shareByEmailRadio = {
    ...styles.shareByEmailRadio,
    css: css`
        ${styles.shareByEmailRadio?.css}
        input[type="radio"] {
            &:disabled {
                & + label {
                    color: ${getColor(colorStrings.commonGlobalGray03)} !important;

                    &::before {
                        border-color: ${getColor(colorStrings.commonGlobalGray03)} !important;
                    }
                }
            }
        }
    `,
};

styles.cancelButtonGridItem = {
    ...styles.cancelButtonGridItem,
    css: css`
        ${styles.cancelButtonGridItem?.css}
        margin-top: 16px !important;
    `,
};

styles.sendButtonGridItem = {
    ...styles.sendButtonGridItem,
    css: css`
        ${styles.sendButtonGridItem?.css}
        margin-top: 16px !important;
    `,
};

styles.shareListTooltip = {
    ...styles.shareListTooltip,
    cssOverrides: {
        ...styles.shareListTooltip?.cssOverrides,
        tooltipBody: css`
            ${styles.shareListTooltip?.cssOverrides?.tooltipBody}
            p, span {
                font-size: 14px;
                font-weight: 400;
                color: ${getColor(colorStrings.textMain)} !important;
                line-height: 1.5;
                background-color: ${getColor(colorStrings.commonGlobalWhite)} !important;
            }
        `,
    },
};

styles.shareByBillingTooltip = {
    ...styles.shareByBillingTooltip,
    mergeCss: true,
    typographyProps: {
        ...styles.shareByBillingTooltip?.typographyProps,
        weight: 400,
        size: 14,
        lineHeight: 1.5,
        color: colorStrings.textMain,
    },
};

styles.shareByEmailTooltip = {
    ...styles.shareByEmailTooltip,
    mergeCss: true,
    typographyProps: {
        ...styles.shareByEmailTooltip?.typographyProps,
        weight: 400,
        size: 14,
        lineHeight: 1.5,
        color: colorStrings.textMain,
    },
};



